import { HttpMethod } from "../common/lib/fetch/useFetch";
import useRequest, { RequestOptions } from "../common/lib/fetch/useRequest";

const useReceivingCompleted = (stagedPurchaseOrderId: string, options?: RequestOptions) =>
  useRequest<void>({
    headers: () => Promise.resolve(new Headers()),
    method: HttpMethod.POST,
    path: `/api/developer/stagedPurchaseOrders/${stagedPurchaseOrderId}/receivingCompleted`
  }, options);

export default useReceivingCompleted;
